module.exports = __webpack_public_path__ + "media/waves.1ef21797.mp4";